import { useParams } from "react-router-dom";
import { DockedChatIsland } from "@/zapi-frontend/shared/ui/ResponsiveChatPanel";
import { ChatIsland } from "@/zapi-frontend/widgets/ChatIsland";
import { TGenerationProgressProps } from "@/zapi-frontend/widgets/ChatIsland/ui/ChatMessageList";
import { TChapter } from "@/zapi-frontend/shared/types/projects";
import {
  countVisibleAssistantMessages,
  useChatUnreadIndicator
} from "@/zapi-frontend/shared/hooks/useChatUnreadIndicator";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";
import { useChatStore } from "@/zapi-frontend/stores/chatStore";
import { useProjectSidebarStore } from "@/zapi-frontend/stores/projectSidebarStore";

type TWorkspaceRoomsIslandProps = {
  chapter?: TChapter;
  askOnly?: boolean;
  generationProgress?: TGenerationProgressProps;
};

export function WorkspaceRoomsIsland({ chapter, askOnly, generationProgress }: TWorkspaceRoomsIslandProps = {}) {
  const { id: projectId = "" } = useParams();
  const activeChapter = useChapterStore((s) => s.activeChapter);
  const chapterId = (chapter ?? activeChapter)?.id.toString() ?? "";
  const assistantMessageCount = useChatStore((s) =>
    countVisibleAssistantMessages(s.chatHistory[`${projectId}:${chapterId}`] ?? [])
  );
  const { hasUnread, markSeen } = useChatUnreadIndicator(assistantMessageCount, {
    ready: chapterId !== "",
    firstVisitKey: projectId ? `project:${projectId}` : undefined,
    conversationKey: chapterId
  });

  const openSidebar = useProjectSidebarStore((s) => s.openSidebar);


  return (
    <DockedChatIsland testId="workspace-rooms-root" hasUnread={hasUnread} hideFab={!!openSidebar} onOpenChange={markSeen}>
      <div data-testid="workspace-rooms-content" className="h-[100svh] hd:h-[calc(100vh-72px)]">
        <ChatIsland chapter={chapter} askOnly={askOnly} generationProgress={generationProgress} />
      </div>
    </DockedChatIsland>
  );
}
